import React from 'react'
import { Button } from 'react-aria-components'
import { useTranslation } from 'react-i18next'

import { Avatar } from '#components/Avatar'
import { Icon } from '#components/Icon'
import { useAuth } from '#hooks/useAuth'
import { getHighestRole, getRoleLabel } from '#interfaces/auth'

import styles from './styles.module.scss'

/** The signed-in user (initials, name, role) and the sign-out button, on the right of the header. */
export const UserChip = (): React.JSX.Element | null => {
  const { t } = useTranslation()
  const { isAuthenticated, user, logout } = useAuth()

  if (!isAuthenticated || !user) return null

  const displayName = (user.displayName ?? [user.firstName, user.lastName].filter(Boolean).join(' ')) || user.email
  const roleLabel = getRoleLabel(getHighestRole(user.roles), t)

  return (
    <div className={styles.userArea}>
      <div className={styles.userPill} data-testid="user-pill">
        <Avatar name={displayName} size="small" shape="squircle" />
        <div className={styles.userInfo}>
          <span className={styles.userName}>{displayName}</span>
          <span className={styles.userRole}>{roleLabel}</span>
        </div>
      </div>
      <Button
        className={styles.logoutButton}
        onPress={(): void => void logout()}
        aria-label={t('Sign out')}
        data-testid="logout-button"
      >
        <Icon name="external-link" width="18" height="18" />
      </Button>
    </div>
  )
}
